import Icon from '@ant-design/icons';
import { ReactComponent as BlockchainSvg } from '../assets/blockchain.svg';

export const BlockIcon = (props: any) => <Icon component={BlockchainSvg} {...props} />;
